import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './common/services/auth.service';
@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'CDM portal';
  private readonly authService = inject(AuthService);

  constructor() {
    // Start idle timer if user is already authenticated (page refresh scenario)
    if (this.authService.isAuthenticated()) {
      this.authService.startIdleTimer();
    }

    // Start idle timer when user logs in
    effect(() => {
      if (this.authService.user()?.email) {
        this.authService.startIdleTimer();
      }
    });
  }
}
